module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-full-f855a35eac0a153b0c928b86340ef02d.webp";